<template>
  <div class="container-fluid p-3"> 
    <div class="card">
      <div class="card-header">
        <h5 class="text-center">LUGARES DECLARADOS</h5>
      </div>
      <div class="card-body">   
      <div >
                      <l-map v-if="showMap" :zoom="zoom" :center="center" :options="mapOptions" style="width: 100%; height: 360px">
                        <l-tile-layer :url="url" :attribution="attribution" />                         
                          <l-marker v-for="resultado in markers" :key='resultado.id' :lat-lng="latlng(resultado.position.lat, resultado.position.lng)" >
                           <l-tooltip :options="{permanent:true, interactive:true}">
                           {{resultado.domicilio}}
                           </l-tooltip>                
                          </l-marker>
                        
                      </l-map>
                    </div>  
      
      </div>
      <div class="card-footer text-center">
      </div>
    </div> 
  </div>
</template>

<script>
//import GoogleMap from "../../components/GoogleMapMarcado";
import 'leaflet/dist/leaflet.css';
import { LMap, LTileLayer, LMarker, LTooltip } from "vue2-leaflet";
//import { L } from "vue2-leaflet";
import { Icon, latLng  } from 'leaflet';
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
  name: 'mapeo',
  data() {
    return {
      zoom: 5,
      zoomLapaz: 5,
      center: latLng(-16.290154,-63.588653),
      centerLapaz: latLng(-16.290154,-63.588653),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(47.41322, -1.219482),
      withTooltip: latLng(47.41422, -1.250482),
      currentZoom: '',
      currentCenter: latLng(-16.5157398,-68.1257891),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5
      },
       mapOptionsLapaz: {
        zoomSnap: 0.8
      },
      showMap: true,
      picked:true,
      picked1:false,

      markers : [],
      datos: [],
      id_persona: 0
    }
  },
  components: {
    //GoogleMap,
    LTooltip,
    LMap,
    LTileLayer,
    LMarker,  
 
  },
  
  methods: {
    latlng(lat, lng){
      return latLng(lat, lng);
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(lat, lng) {
      this.currentCenter = latLng(lat,lng);
    },

    async listaCoordenadas(id){
      let resultados = await this.axios.get(`domicilio/declaraciones/${id}`);
      this.markers = resultados.data.contenido; 
    }
  },
  mounted(){  
    this.id_persona = this.$route.params.id;
    this.listaCoordenadas(this.id_persona);
  }
}
</script>
